import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_FONT } from '../../theme/customizer-tokens';

/** Desktop wizard shell: header row, a [center body · right progress] main row,
 *  and a centred footer CTA. The mobile flow renders its own shell (mobile/). */
export const DesktopShell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 24px 48px 32px;
`;

export const Main = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  gap: 48px;
  padding-top: 12px;
`;

/** Left column: the step content (grows) above the step footer. Sits beside the
 *  progress sidebar, so the footer stretches only to the sidebar, not under it. */
export const LeftCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

/** Center column: the step body (e.g. the country dropdown above the world map).
 *  The top padding drops the step content so its first row (e.g. the "Refresh
 *  suggestions" header) lines up with the progress panel's title, which sits a
 *  panel border (1px) + Head padding (24px) below the column top. */
export const CenterCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 25px;
  /* The wizard shell is a fixed, non-scrolling viewport. If a step's content is
     ever taller than the room left between the header and the footer, scroll it
     WITHIN this column rather than letting it spill over the pinned footer and
     cover the Continue button. Horizontal stays hidden so card edges never bleed. */
  overflow-y: auto;
  overflow-x: hidden;
`;

/** Right column — fixed-width progress panel pinned to the top. */
export const RightCol = styled.div`
  flex: 0 0 320px;
  width: 320px;
`;

/** Step footer row: full width of the LeftCol (stretches to the sidebar). */
export const FooterRow = styled.div`
  flex: 0 0 auto;
  display: flex;
  width: 100%;
  padding-top: 16px;
`;

export const ErrorScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  width: 100%;
  text-align: center;
  padding: 24px;
  font-family: ${CUST_FONT};
`;

export const ErrorTitle = styled(Text)`
  font-size: 22px;
  font-weight: 700;
  color: ${CUST.white};
`;

export const ErrorBody = styled(Text)`
  font-size: 15px;
  color: ${CUST.textMuted};
`;